import PropTypes from 'prop-types';

const displayName = 'BillerPage';
const propTypes = {
  deviceHeight: PropTypes.number,
  isLoading: PropTypes.bool,
  getService: PropTypes.func,
  getAuthToken: PropTypes.func,
  getListBillerByService: PropTypes.func,
  billerList: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  intl: PropTypes.object,
};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
